import { defineComponent, h, markRaw, type Component } from 'vue';
import AppIcon from '@/components/AppIcon.vue';
import type { IconName } from '@/lib/icons';

// Adapts AppIcon (name-based) into the `Component` slot a few APIs expect: a Vue
// icon component taking a numeric `size` (the @hq/chat-ui icon contract, and any
// prop typed `icon: Component`). Use this when something needs an icon COMPONENT
// rather than an <AppIcon> tag in a template. Keeps the icon set in one place
// (lib/icons.ts) while staying compatible with the library-agnostic chat-ui API.
export function iconComp(name: IconName): Component {
  return markRaw(defineComponent({
    name: `Icon-${name}`,
    props: { size: { type: [Number, String], default: 18 } },
    setup(props) {
      return () => h(AppIcon, { name, size: props.size });
    },
  }));
}
